import { Component } from 'vue-property-decorator'
import Vue from '@src/vue'
import './loading-screen.sass'
import { Loader } from '@src/components/loading-screen/loader/loader'

@Component
export class LoadingScreen extends Vue {
  render (h) {
    return <div class='loading-screen'>
      <Loader/>
    </div>
  }
}
